import type { IconNode } from '../types';

/**
 * @name egg-cup
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggMTFjMC0zLjMtMi43LTktNi05cy02IDUuNy02IDkiIC8+CiAgPHBhdGggZD0iTTE5IDExYTcgNyAwIDEgMS0xNCAwWiIgLz4KICA8cGF0aCBkPSJNMTIgMTh2NCIgLz4KICA8cGF0aCBkPSJNOSAyMmg2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/egg-cup
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const eggCup: IconNode = [
  ['path', { d: 'M18 11c0-3.3-2.7-9-6-9s-6 5.7-6 9', key: '4quedx' }],
  ['path', { d: 'M19 11a7 7 0 1 1-14 0Z', key: 'w8qu0c' }],
  ['path', { d: 'M12 18v4', key: 'jadmvz' }],
  ['path', { d: 'M9 22h6', key: '1rlq3v' }],
];

export default eggCup;
